<template>
	    <section class="section-main">
					<div class="content" v-if="showModule=='module'">
	        	<div class="e-fixed">
		          <div class="hotel-name" style="padding-right: 300px;">
		                {{hotelName}}
										<div class="batch-btn" v-if="roomList&&roomList.length>0" @click="toRootStatusBatch">批量维护</div>
										<!-- <div class="batch-btn table-btn" @click="showModule='list';tableModule('list')">日历模式</div> -->
		            </div>
		            <div class="filter">
		                <div class="choose-date">
											<div class="date-choose-input" style="margin-right:32px;">
												<div class="btn-mask" @click="datePickerData.show=true"></div>
												<input type="text"  v-model="beginSlot" disabled name="date"> 
												-
												<input type="text"  v-model="endSlot" disabled name="date">
											</div>
											<div class="bimestrial" style="left: auto;right: 0;">
												<datePicker v-if="datePickerData.show" :value='datePickerData.value' @onDateChange="datePickerData.onDateChange" ></datePicker>
											</div>
											
											<!-- <calendar v-if="calendar.show" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value" :begin="calendar.begin"  @select="calendar.select"></calendar> -->
		                </div>
		            </div>
	      		</div>
						<div class="weekTable" ref="weekTable">
							<div class="allShow" @click="handleBox">{{allShow?'收起全部房型':'展开全部房型'}}
								<img v-if="allShow" src="../../assets/images/right.png" mode="scaleToFill">
								<img v-else class="reverse" src="../../assets/images/right.png" mode="scaleToFill">
							</div>
							<div class="weekItem" v-for="(d,index) in dateList" :class="(getWeekday(d)==0||getWeekday(d)==6)?'bold':''">
								<span class="select-arrow arrow-left" :class="isDisabled?'disabled':''" @click="add(false)" v-if="index==0"></span>
									<p>{{d|delUTC|dateWeek}}</p>
									<p>{{d|delUTC|dateShortE}}</p>
									<span class="select-arrow arrow-right" @click="add(true)" v-if="index==9"></span>
							</div>
						</div>
						<div class="weekTable box-fixed" v-if="showFixed">
							<div class="fixed-shadow"></div>
							<div class="weekItem" v-for="(d,index) in dateList" :class="(getWeekday(d)==0||getWeekday(d)==6)?'bold':''">
								<span class="select-arrow arrow-left" :class="isDisabled?'disabled':''" @click="add(false)" v-if="index==0"></span>
									<p>{{d|delUTC|dateWeek}}</p>
									<p>{{d|delUTC|dateShortE}}</p>
									<span class="select-arrow arrow-right" @click="add(true)" v-if="index==9"></span>
							</div>
						</div>
	          <div class="roomTable" v-for="(list,index)  in roomList">
		            <div class="roomTitle">
									<div class="left" @click="list.show = !list.show">
										<div class="roomName">
											{{list.Name}} 
										</div>
										<div class="abElement">
											<img v-if="list.show" src="../../assets/images/right.png" mode="scaleToFill">
											<img v-else class="reverse" src="../../assets/images/right.png" mode="scaleToFill">
										</div>
									</div>
									<div class="right" v-for="S in shareData"  v-if="S.RoomId==list.RPS[0].RoomId">
											<div v-for="share in S.RoomStatusInfos" style="width: 10%;height: 100%;">
												<div v-if="share.IsShared" :class="share.RoomStatusId=='026001'?'itemBtn':'itemBtn no'" @click="setShare(share,list.RPS)">
													<div class="el yes" v-if="share.RoomStatusId=='026001'"><img src="../../assets/images/yes.png" mode="scaleToFill" ></div>
													<div class="el no" v-else><img src="../../assets/images/no.png" mode="scaleToFill"></div>
													<div class="num hover" @click.stop="toRoomStatusSingleEdit(share,list)">
														<div class="count" style="font-weight: bold;">{{share.SharedStockNum}}</div>
														<div class="alter">修改房量</div>
														<div class='text' v-if='share.IsAllowOverBook'>可超售</div>
														<div class='text' v-else-if='!share.IsAllowOverBook' style='color: #0b0b0b;'>不可超</div>
													</div>
												</div>
											</div>
									</div>
								</div>
								<div :class="list.show?'roomContent expanded':'roomContent'" ref="content" :style="{ maxHeight: list.show ? list.contentHeight + 'px' : '0' }">
									<div v-for="item in list.RPS" :key="item.RateId">
										<DateTable :beginSlot='beginSlot' :rps="item" :rooms='list' @select="TableSelect"></DateTable>
										
									</div>
								</div>
		        </div>
						<RoomStatusBatchEdit @saveDate="saveDate" :cmData="cmBatchData" :cmroomList="cmroomList" ></RoomStatusBatchEdit>
						<RoomStatusSingleEdit :cmData="cmData" :rooms='cmRooms' @saveShare='saveShare'></RoomStatusSingleEdit>
	        </div>


        <div class="content" v-if="showModule=='list'">	
        	<div class="e-fixed">
	            <div class="hotel-name" style="padding-right: 300px;">
	                {{hotelName}}
	                <div class="batch-btn" v-if="roomList&&roomList.length>0" @click="toRootStatusBatch">批量维护</div>
									<div class="batch-btn table-btn" @click="showModule='module';tableModule('module');beginSlot=this.getDate(0)">表格模式</div>
	            </div>
	            <div class="filter">
	                <ul class="filter-list">
	                      <li :class="roomRpsActive==index?'list-item active':'list-item'" v-for="(room,index) in roomList" @click="switchHotel(room,index)">{{room.Name}}</li>
	                </ul>
	                <div class="choose-date">
	                    <div class="select"  >
	                        <select name="year" v-model="year" >
	                            <option :value="year" v-for="year in years" >{{year}}年</option>
	                        </select>
	                    </div>
	                    <div class="select">
	                    	<span class="select-arrow arrow-left" @click="lastMonth"></span>
	                        <select name="month" v-model="month">
	                            <option :value="month" v-for="month in ['01','02','03','04','05','06','07','08','09','10','11','12']">{{month}}月</option>
	                        </select>
	                        <span class="select-arrow arrow-right" @click="nextMonth"></span>
	                    </div>
	                </div>
	            </div>
            </div>
            <div class="room-date-table" v-for="rps in roomRps.RPS" :key="rps.RateId">
	            <div class="room-info">
	                <div class="room-title">{{rps.PriceTypeName+'&nbsp;&nbsp;&nbsp;'+rps.RatePlanName}}</div>
	            </div>
				
	            <DatePriceTable  :rps="rps" v-if="rps" :date="date" ></DatePriceTable>
	           
            </div>
            <RoomStatusBatchEdit @saveDate="saveDate" :cmData="cmBatchData" :cmroomList="cmroomList" ></RoomStatusBatchEdit>
        </div>
    </section>
</template>
<script>
import DatePriceTable from './datePriceTable/datePriceTable.vue'
import DateTable from './datePriceTable/table.vue'
import RoomStatusBatchEdit from './datePriceTable/roomStatusEdit/RoomStatusBatch.vue'
import RoomStatusSingleEdit from './datePriceTable/roomStatusEdit/RoomStatusSingle.vue'
import Calendar from './../../common/calendar/calendar.vue'//日期选择器
import DatePicker from './../../common/DatePicker/DatePicker.vue'
export default {
  	name: 'roomStatus',
  	components:{
			DatePriceTable,
			RoomStatusBatchEdit,
			RoomStatusSingleEdit,
			DateTable,
			Calendar,
			DatePicker
  	},
  	data(){
        return {
					hotelName:this.dao.get('HotelName')||'',
					hotelId:this.dao.get('HotelId'),
					roomList:[],
					cmroomList:[],
					roomRps:'',
					cmBatchData:{},
					roomRpsActive:0,
					years:this.getYears(),
					year:this.getYears()[0],
					month:this.getMonth(),
					date:String(this.getYears()[0]+''+this.getMonth()),
					beginSlot:this.getDate(0),
					endSlot:this.getDate(9),
						calendar:{
							display:"",
							show:false,
							zero:true,
							begin:this.getDate(0).split('-'),
							value:[],
							lunar:false, //显示农历
							select:(value)=>{
									if(!value){
											this.calendar.show=false;
											return;
									}
									this.beginSlot=value.join('-');
									this.calendar.value=value;
									this.endSlot=this.getNextDay(this.beginSlot,9);
									this.calendar.show=false;
									this.initDate()
							}
						},
						dateList:'',
						showModule:'module',
						isDisabled:true,
						showFixed:false,
						allShow:true,
						OrC:true,
						labelContent:false,
						shareData:[],
						cmData:{
							PD:'',
							S:'',
							A:false,
							IsShared:true,
							hidden:true
						},
						cmRooms:{},
						datePickerData:{
							value:this.getDate(0),
							show:false,
							onDateChange:(date)=>{
								if(!date){
									this.datePickerData.show=false;
									return;
								}
								this.beginSlot=date;
								this.datePickerData.value=date;
								this.endSlot=this.getNextDay(this.beginSlot,9);
								this.datePickerData.show=false;
								this.initDate()
							}
						}
        }
  	},
  	watch:{
			year(val){
				this.date=val+this.month;
			},
			month(val){
				this.date=this.year+val;
			},
			beginSlot(val){
					if(this.beginSlot==this.getDate(0)){
						this.isDisabled = true
					}else{
						this.isDisabled = false
					}
					this.initDate()
					var that = this
					that.datePickerData.value = val
					that.shareData=[]
					that.roomList.forEach((item) => {
						that.getRps(item)
					})
					
			},
			showModule(val){
				if(val=='module'){
					window.addEventListener('scroll', this.scrollFixed);
				}else if(val=='list'){
					window.removeEventListener('scroll', this.scrollFixed);
				}
			},
			roomList: {
				deep: true, 
				handler() {
					if (this.roomList.every((item) => item.show === true)) {
						this.allShow = true;
					}
					else if (this.roomList.every((item) => item.show === false)) {
						this.allShow = false;
					}
				},
			},
  	},
  	methods:{
				
				//编辑单独一列的房量
        toRoomStatusSingleEdit(share,list){
					var cmData={
						PD:share.Date,
						S:share.RoomStatusId,
						A:false,
						SC:share.SharedStockNum,
						IsShared:true,
						hidden:true,
					}
          if(this.getDaysSize(this.today,share.Date)<0)return;//先判断当期日期是否可以编辑
          this.cmData = JSON.parse(JSON.stringify(cmData));
					this.cmRooms = JSON.parse(JSON.stringify(list));
          this.$nextTick(function () {
            this.$set(this.cmData,'isShow',this.cmData.isShow?false:true);
						this.$set(this.cmRooms);
          });
        },
				handleBox(){
					var that = this
					that.allShow=!that.allShow
					that.roomList.forEach(item=>{
						item.show=that.allShow
					})
				},
				// 切换日期
				add(flag){
            if(flag){
                this.beginSlot = this.getNextDay(this.beginSlot,10)
								this.initDate()
            }else{
                var num = this.getDaysSize(this.getDate(0),this.beginSlot)
                if(num<=10){
                    this.beginSlot = this.getDate(0)
										this.initDate()
                }else if(num>10){
                    this.beginSlot = this.getLastDay(this.beginSlot,10)
										this.initDate()
                }
            }
        },
				// 初始化日期列表
				initDate(){
            var arr=[]
            var date =''
            for(var i = 0;i<=9; i++){
                if(i==0){
                    date = this.beginSlot
                }else{
                    date = this.getNextDay(this.beginSlot,i)
                }
                arr.push(date)
            }
            this.dateList=arr
        },
				TableSelect(value,list){
					if(!value)return;
					if(list==1){
						this.getRoomType();
					}else{
						this.beginSlot = value
						this.endSlot = this.getNextDay(value,9)
						this.calendar.value=value.split('-')
					}
					
				},
	  	lastMonth(){
	  		var now=this.year+'-'+this.month;
	  		if(this.getSearchMonth(now,-1)[0]<this.getYears()[0]){
	  			return;
	  		}
	  		this.month=this.getSearchMonth(now,-1)[1];
	  		this.year=this.getSearchMonth(now,-1)[0];

	  	},
	  	nextMonth(){
			var now=this.year+'-'+this.month;
			if(this.getSearchMonth(now,1)[0]>this.getYears()[4]){
	  			return;
	  		}
	  		this.month=this.getSearchMonth(now,1)[1];
	  		this.year=this.getSearchMonth(now,1)[0];
	  	},
	  	getSearchMonth(dat,count){
	  		var date = new Date(dat);
			
	        date.setMonth(date.getMonth() + count,1);
	        var year = date.getFullYear();
	        var month = date.getMonth() + 1;
	        if (month < 10) { month = '0' + month };
	        month=String(month);
	        return [year,month];
	  	},
	   //切换房型
			switchHotel(room,index){
				
				this.roomRps=room;
				this.roomRpsActive=index;


			},
			getRps(item){
				var that=this;
				var params={
					HotelId: that.hotelId,
					RoomId:item.RPS[0].RoomId,
					Date:that.dateList[0],
				}
				that.postRequest({
					url: that.Api.getRps,
					params: params
				}).then(res => {
					if(res[0]){
						if(res[0].RoomStatusInfos&&res[0].RoomStatusInfos.length>0){
							res[0].RoomStatusInfos.forEach(item=>{
								item.mouse = false
							})
						}
						that.shareData=res.concat(that.shareData)
					}
					
				});
			},
			getRoomType(){
				var that=this;
						var params={
							hid: that.hotelId
						}
				that.getRequest({
								url: that.Api.getRoomsList,
								params: params
						}).then(res => {
							if(res&&res.length>0){
								res.forEach(item=>{
									item.show = true
									item.IsShared = true
									if(item.RPS.length<2){
										item.IsShared = false
									}
									item.contentHeight = 10000; 
								})
								
								that.roomList=res;
								that.roomRps=res[that.roomRpsActive];

								that.$nextTick(() => {
									that.shareData=[]
									that.roomList.forEach((item) => {
										that.getRps(item)
										item.contentHeight = (100*item.RPS.length)+100
									})
								})
								// 确保 DOM 更新完成后计算高度
								// that.$nextTick(() => {
								// 	that.roomList.forEach((item, index) => {
								// 		const contentElement = that.$refs.content[index];
								// 		if (contentElement) {
								// 			// 使用 Promise 来确保高度计算完成
								// 			new Promise((resolve) => {
								// 				const interval = setInterval(() => {
								// 					if (contentElement.scrollHeight > 0) {
								// 						clearInterval(interval);
								// 						resolve();
								// 					}
								// 				}, 100);
								// 			}).then(() => {
								// 				item.contentHeight = contentElement.scrollHeight;
								// 			});
								// 		}
								// 	});
								// });
							}
						});

			},
			setRoomStuts(day){
    		var that=this;
    		var rps=that.rps;
        var RPInfos=[{
					RPId:rps.RatePlanId,
					RateId:rps.RateId
				}]
				var params={
					HotelId: rps.HotelId,
					RoomId: rps.RoomId,
					RPInfos:RPInfos,
					Date:day.PD,
					IsOpen:day.S=='026001'?false:true,
					IsAsk:day.A,
					Count:day.SC||0,
					AllowOver:day.O,
					IsShared:day.IsShared,
					IsOnlyChangeRoomStatus:true
	      }
	        that.patchRequest({
	            url: that.Api.updateStateSingle,
	            params: params
	        }).then(res => {
	            if (res&&res.IsSuccess) {
	               that.getRoomType()
	              //  that.error({ title: '提示', content: '保存成功' });
	            } else {
	                that.error({ title: '提示', content: res.Msg||'提交失败，请重新提交' });
	            }
	        });
    	},
			setShare(share,list){
					share.RoomStatusId=='026001'?share.RoomStatusId='026002':share.RoomStatusId='026001'
					var that=this;
					var arr = []
					if(list&&list.length>0){
						list.forEach(element => {
							var obj={}
							obj.RPId=element.RatePlanId
							obj.RateId=element.RateId
							arr.push(obj)
						});
					}
					var params={
	          	HotelId: list[0].HotelId,
	          	RoomId: list[0].RoomId,
							RPInfos:arr,
							Date:share.Date,
							IsOpen:share.RoomStatusId=='026001'?true:false,
							IsShared:true,
							IsOnlyChangeRoomStatus:true
	        }
	        that.patchRequest({
	            url: that.Api.updateStateSingle,
	            params: params
	        }).then(res => {
	            if (res&&res.IsSuccess) {
									that.getRoomType()
									// that.error({ title: '提示', content: '保存成功' });
	            } else {
	                that.error({ title: '提示', content: res.Msg||'提交失败，请重新提交' });
	            }
	        });
    	},
			saveShare(){
				this.getRoomType();
							this.$nextTick(function () {
								this.$set(this.cmData,'isShow',false);
			　　　　 });
			},

			saveDate(){
				this.getRoomType();
							this.$nextTick(function () {
									this.$set(this.cmBatchData,'isShow',false);
			　　　　 });
			},
			toRootStatusBatch(){
				this.cmroomList=JSON.parse(JSON.stringify(this.roomList));
							this.$nextTick(function () {
									this.$set(this.cmBatchData,'isShow',true);
			　　　　 });
			},
			getYears(){
				var da = new Date();
							var year=da.getFullYear();
							var result=[];
							for(var i=0;i<5;i++){
								result.push(year+i)
							}
				return result
			},
			getMonth(){
				var da = new Date();
							var month = da.getMonth()+1;
							if(month<10){month='0'+month};
				return month
			},
			scrollFixed(){
					const weekTable = this.$refs.weekTable;
					const rect = weekTable.getBoundingClientRect();
					const topPosition = rect.top + window.scrollY;
					const scrollTop = window.pageYOffset || document.documentElement.scrollTop
					if(scrollTop>=topPosition){
						this.showFixed = true
					}else{
						this.showFixed = false
					}
			}

		},
			
  	mounted(){
  		if(!this.hotelName){
  			this.$router.push('/index');
  			return;
  		}
			this.initDate()
  		this.getRoomType();
			if(this.showModule=='module'){
				window.addEventListener('scroll', this.scrollFixed);
			}
  	},
		beforeDestroy() {
			window.removeEventListener('scroll', this.scrollFixed);
		},
}

	
</script>


// WEBPACK FOOTER //
// src/components/roomStatus/RoomStatus.vue